import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';

const COLORS = ['#FF6B00', '#437011', '#2563EB', '#8B5CF6', '#EC4899', '#F59E0B'];

const PieChartCard = ({ data, title, gradientColors }) => {
  if (!data || data.length === 0) return null;

  // Filter out small values for better display and sort by value
  const sortedData = [...data]
    .filter(d => d.value > 0)
    .sort((a, b) => b.value - a.value)
    .slice(0, 5); // Max 5 items

  const total = sortedData.reduce((sum, item) => sum + item.value, 0);

  // Custom label renderer
  const renderCustomLabel = ({ name, value, percent }) => {
    if (percent < 0.05) return null; // Don't show label if less than 5%
    return `${(percent * 100).toFixed(0)}%`;
  };

  return (
    <div className="bg-white rounded-xl shadow-md border border-gray-100 overflow-hidden">
      <div className="h-2" style={{ background: gradientColors || 'linear-gradient(135deg, #FF6B00 0%, #FF9248 100%)' }}></div>
      <div className="p-4">
        <h3 className="text-base font-semibold text-gray-800 mb-2 truncate" title={title}>{title}</h3>
        <div className="h-56">
          <ResponsiveContainer width="100%" height="100%">
            <PieChart>
              <Pie
                data={sortedData}
                cx="45%"
                cy="50%"
                labelLine={false}
                label={renderCustomLabel}
                outerRadius={65}
                fill="#8884d8"
                dataKey="value"
              >
                {sortedData.map((entry, index) => (
                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Tooltip 
                contentStyle={{ backgroundColor: '#fff', borderRadius: '8px', border: '1px solid #e5e7eb', fontSize: '12px' }}
                labelStyle={{ color: '#374151' }}
                formatter={(value, name) => [`${value} (${((value/total)*100).toFixed(1)}%)`, name]}
              />
              <Legend 
                layout="vertical" 
                verticalAlign="middle" 
                align="right"
                wrapperStyle={{ fontSize: '11px', paddingLeft: '10px' }}
              />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </div>
    </div>
  );
};

export default PieChartCard;
